import { isEmpty } from 'lodash';

import { VERTICAL_FILTER_STORAGE_ID } from 'components/Common/VerticalFilterV2/constants';
import {
  DISTRICT_ON,
  PERSISTED_VERTICAL_FILTERS_KEY,
} from 'constants/verticalFilterLocalStorage';

const districtExists = previousDistrict =>
  !isEmpty(previousDistrict) && previousDistrict !== 'null';

const storeVerticalFilters = () => {
  const previousDistrict = localStorage.getItem(DISTRICT_ON);
  const previousVerticalFilters = JSON.parse(
    localStorage.getItem(VERTICAL_FILTER_STORAGE_ID) || '{}',
  );
  const cachedVerticalFilters = JSON.parse(
    localStorage.getItem(PERSISTED_VERTICAL_FILTERS_KEY) || '{}',
  );
  const updatedCache = {
    ...cachedVerticalFilters,
    ...(districtExists(previousDistrict)
      ? { [previousDistrict]: previousVerticalFilters }
      : {}),
  };
  localStorage.setItem(
    PERSISTED_VERTICAL_FILTERS_KEY,
    JSON.stringify(updatedCache),
  );
};

export default storeVerticalFilters;
